import { commonConstants } from '../_constants';
import { initialState } from '../_helpers';

export function flagMetrics(state=initialState.flagMetrics, action) {
     switch (action.type) {
        case commonConstants.GET_FLAG_METRICS:
            return Object.assign({}, state, action.flagMetrics);
        default:
          return state
      }
}


// WEBPACK FOOTER //
// ./src/_reducers/flagMetrics.reducer.js